import { Weight } from '@shared/types/parcel';
import { DataRow } from '@uni-space/uni-components';

export type SuccessRow = DataRow<{
  trackNumber: string;
  regionZone: string;
  bagCode: string;
  sortingCode: string;
  weight: number | null;
  scanAt: Date;
  id: string;
}>;

export type ErrorRow = DataRow<{
  trackNumber: string;
  status: StatusAcceptanceEnum;
  id: string;
}>;

export interface ParcelAcceptanceRequest {
  trackNumber: string;
  actualWeight: number;
  factWeight: number;
  dimensions: ParcelDimensions;
}

// The acceptance API uses numeric SizeUnit values: cm = 1.
export interface ParcelDimensions {
  length: { value: number; unit: 1 };
  width: { value: number; unit: 1 };
  height: { value: number; unit: 1 };
}

export interface Parcel {
  trackNumber: string;
  actualWeight: Weight;
  sortingCode: string;
  scanAt: Date;
  isQualityControl: boolean;
  regionZone: string;
  bagCode: string;
  postalLabel?: string;
  azLabel?: string;
}

export interface ParcelAcceptanceResponse {
  status: StatusAcceptanceEnum;
  parcel: Parcel;
}

export interface ParcelAcceptanceResponse {
  status: StatusAcceptanceEnum;
  parcel: Parcel;
}
export enum StatusAcceptanceEnum {
  Already = 0,
  Canceled = 1,
  Accepted = 2,
  AlreadyAnotherWarehouse = 3,
  ServiceRestriction = 4,
  NotFound = 5,
  UserNotFound = 6,
  QualityControl = 7,
  ApiError = 8,
  AcceptedNeedGroundTransport = 9,
  HighDensity = 10,
  InvalidDimensions = 11,
}

export interface ParcelChangeWeightRequest {
  trackNumber: string;
  weight: {
    unit: number;
    value: number;
  };
}

export interface ParcelChangeDimensionsRequest {
  trackNumber: string;
  dimensions: ParcelDimensions;
}
